import React from "react";
export const BtnSuDung = ({ item, onUse, CustomCheckbox }) => {
   const uniqueId = `custom-switch-${item.ConfigPhiKhacId}`; 
    return (
            <CustomCheckbox
                id={uniqueId}
                name={uniqueId} 
                checked={item.Active}
                onChange={() => onUse(item)}
                label="" 
                className="d-flex justify-content-center" 
            />
    );
};